<template>
	<div>
		<div v-if="noContent" id="panel_announces_2" class="my-4 announces">
			<div v-if="Items.length > 0" class="container">
				<ul class="announce_list">
					<li v-for="(item, index) in items.data" :key="index" class="row">
						<div class="col-12 col-sm-8 col-md-4 col-lg-4">
							<div class="announce_image_block">
								<nuxt-link target="_blank" :to="'/courses/' + item.id">
									<b-img-lazy
										v-if="item.top_cover_image_default"
										:src="item.top_cover_image_default.src"
										:alt="item.top_cover_image_default.alt"
									/>
								</nuxt-link>
							</div>
						</div>

						<div
							class="col-12 col-sm-12"
							:class="[ (item.progress && item.progress.max !== 0) ? 'col-lg-4 col-md-4' : 'col-lg-8 col-md-8']"
						>
							<div class="announce_content_block">
								<div class="announce_content_header">
									<ul class="tag_list">
										<li>
											<a
												v-if="item.short_title"
												:href="'/courses/' + item.id"
											>
												{{ item.short_title }}
											</a>
										</li>
									</ul>
								</div>
								<div class="announce_content_middle">
									<p>{{ item.start_at | moment("HH MMMM YYYY") }}</p>
									<a
										v-if="item.title"
										class="title announce_title"
										:href="'/courses/' + item.id"
									>
										{{ item.title }}
									</a>
									<p v-if="item.subtitle" class="description">
										{{ item.subtitle }}
									</p>
								</div>
								<div class="announce_content_footer">
									<nuxt-link
										v-if="item.title"
										class="more_link"
										:to="'/courses/' + item.id + '/'"
									>
										{{ $t('moreDetails') }}
									</nuxt-link>
								</div>
							</div>
						</div>

						<div
							v-if="(item.progress && item.progress.max !== 0)"
							class="col-12 col-sm-2 col-md-2 col-lg-2"
						>
							<div v-if="item.progress" class="announce_progress_block">
								<div class="progress-label">
									<span>{{ item.progress.confirm }}</span> из <span>{{ item.progress.max }}</span>
								</div>
								<div>
									<b-progress :max="item.progress.max" class="">
										<b-progress-bar :value="item.progress.confirm" />
									</b-progress>
								</div>
							</div>
						</div>
					</li>
				</ul>
				<b-pagination
					v-if="items && items.meta && noContent"
					v-model="page"
					:total-rows="items.meta && items.meta.total || 0"
					:per-page="items.meta && items.meta.per_page || 0"
					:limit="7"
					align="center"
					pills
					hide-goto-end-buttons
					next-class="pagination-next"
					prev-class="pagination-prev"
					prev-text=""
					next-text=""
				/>
			</div>
		</div>
	</div>
</template>

<script>
import '@/utils/moment';
import { directive, Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
	name: 'ProfileCourses',
	components: {
		Swiper,
		SwiperSlide,
	},
	directives: {
		swiper: directive,
	},
	props: {
		noContent: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			items: null,
			events: null,
			options: {
				slidesPerView: 'auto',
				// spaceBetween: 40,
				// cssMode: false,
				// freeMode: true,
				loop: false,

				navigation: {
					nextEl: '#swiper-review-next',
					prevEl: '#swiper-review-prev',
					disabledClass: 'disabled',
				},
			},
		};
	},
	async fetch() {
		const { query } = this.$route;
		const params = {
			page: query.page,
		};
		try {
			this.items = await this.$api.courses(params);
		} catch (error) {
			console.error(error);
			throw new Error(error.message);
		}

		if (this.items && this.items.data) {
			this.items.data.forEach((course) => {
				this.$api.courseProgress(course.id).then((response) => {
					this.$set(course, 'progress', response);
				});
			});
		}
	},
	computed: {
		Items() {
			return this.items && Array.isArray(this.items.data)
				? this.items.data : [];
		},
		page: {
			get() {
				return this.$route.query.page || 1;
			},
			set(page) {
				this.$router.push({
					query: {
						...this.$route.query,
						page: page > 1 ? page : undefined,
					},
				});
			},
		},
		prevElId() {
			return this.options.navigation.prevEl.slice(1);
		},
		nextElId() {
			return this.options.navigation.nextEl.slice(1);
		},
	},
	watch: {
		'$route.query': {
			async handler() {
				this.$scrollTo('#scroll-on-page-change');
				this.$fetch();
			},
		},
	},
	beforeCreate() {
		this.$route.params.title = 'Записи мероприятий';
	},
	mounted() {
		this.$api.recommendedEvents()
			.then((data) => {
				this.events = data.data;
			});
	},
	methods: {
		one(slug, typology, query, ...rest) {
			return this.$url.event(slug, typology, { query, ...rest });
		},
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-announces";
	@import "~/assets/styles/components/dev/draft-cards-1";
	@import "~/assets/styles/components/dev/dashboards-events";
	@import "~/assets/styles/components/dev/courses-header";
	.programm {
		border:1px solid;
	}
	.programm_content_footer {
		border-top: 0;
		margin-top: 0;
		padding-top: 0;
	}
</style>
